require('./style.scss')
angular = require('angular')
pkg = angular.module 'cdms.device', [
    require('angular-ui-router')
    require('./details')
    require('./usage')
    require('./statistic')
    require('./remote')
    require('./terminal')
    require('./bulk-action')
    require('./firewall-test')
  ]
  .config ($stateProvider) ->
    $stateProvider
      .state 'devices',
        url: "/devices?tag"
        template: require('./index.pug')
        controller: 'DeviceCtrl'
        authenicate: true
  .controller('DeviceCtrl', require("./controller"))
  .factory('Device', require("./device"))
  .service('pusher', require("./pusher"))

module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/device/index.coffee